import {
  LeftElementsContainer,
  RightElementsContainer,
  TopNavigationContainer
} from './styled-components.js'

const TopNavigationComponent = ({ rightItems, leftItems }) => {
  return (
    <TopNavigationContainer>
      <LeftElementsContainer>
        {leftItems.map((item) => item)}
      </LeftElementsContainer>
      <RightElementsContainer>
        {rightItems.map((item) => item)}
      </RightElementsContainer>
    </TopNavigationContainer>
  )
}

export default TopNavigationComponent
